import * as base from './environment.base';

export const environment = {
	...base.environment,
	production: true,
};
